import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateChildFn, RouterStateSnapshot } from '@angular/router';
import { of } from 'rxjs';
import { switchMap, take } from 'rxjs/operators';

import { UserStoreService } from '@auth/store/services/user-store.service';
import { RpcRoute } from '@core-layout/app/models/rpc-route';
import { RouteService } from '@core-layout/app/services/route.service';

export const agentSelectionGuard: CanActivateChildFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
    const routeService = inject(RouteService);

    return inject(UserStoreService).selectLoginProcessData$.pipe(
        take(1),
        switchMap(processData => {
            if (processData != null) {
                return of(true);
            }

            routeService.navigate(RpcRoute.Login).catch(() => { });

            return of(false);
        })
    );
};